import React from 'react'

import ForgotPasswordLink from './ForgotPasswordLink';
import RecaptchaInfo from '../RecaptchaInfo';
import EmailInput from '../../../ui-components/EmailInput';
import PasswordInput from '../../../ui-components/PasswordInput';
import SubmitButton from '../../../ui-components/SubmitButton';
import {CreateUserSession} from '../../../apis/UserSessionAPI';
import AlertModal from "../../../ui-components/AlertModal";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";
import Label from "../../../ui-components/Label";
import { InputStyles } from "../../../ui-components/BaseInput";

export default class EmailSignInForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            isLoading: false
        };
    }

    handleEmailChanged = (event) => {
        this.setState({
            email: event.target.value
        });
    };

    handlePasswordChanged = (event) => {
        this.setState({
            password: event.target.value
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();

        if (!this.state.email || !this.state.password) {
          this.setState({errorModalText: I18n.t('pages.user_session.user.errors.wrong_data')});
          return
        }

        this.setState({isLoading: true})

        grecaptcha.enterprise.ready(async () => {

          const recaptchaToken = await grecaptcha.enterprise.execute(process.env.GOOGLE_RECAPTCHA_KEY_ID, {action: 'LOGIN'});

          CreateUserSession(this.state.email, this.state.password, recaptchaToken)
            .then((res) => {
              this.setState({isLoading: false})

              if (this.props.onLogin) {
                this.props.onLogin(res);
              }
            })
            .catch((error, response) => {
              let message = ""

              switch (error.status) {
                case 429:
                  message = I18n.t('pages.user_session.user.errors.max_reached')
                  break
                case 422:
                  message = I18n.t('pages.user_session.user.errors.wrong_recaptcha')
                  break
                default:
                  message = I18n.t('pages.user_session.user.errors.wrong_data')
              }

              this.setState({errorModalText: message, isLoading: false});
            });
        });
    }

    render() {
        return (
            <div>
                <AlertModal title="Attenzione!"
                            text={this.state.errorModalText}
                            show={!!this.state.errorModalText}
                            onClose={() => this.setState({errorModalText: null})}/>

                <form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col sm={12}>
                          <Label>{I18n.t("pages.user_session.user.email")}</Label>
                            <EmailInput
                                name="user_email"
                                value={this.state.email}
                                inputStyle={InputStyles.Rounded}
                                onChange={this.handleEmailChanged}/>

                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Label>{I18n.t("pages.user_session.user.password")}</Label>
                            <PasswordInput
                                name="user_password"
                                value={this.state.password}
                                onChange={this.handlePasswordChanged}/>
                            <ForgotPasswordLink />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <SubmitButton className="sign-user-page-btn"
                                          ariaDisabled={this.state.isLoading}
                                          value={this.state.isLoading ? I18n.t("wait") + "..." : I18n.t('sign_in')}/>
                        </Col>
                    </Row>

                    <Row>
                      <Col sm={12}>
                        <RecaptchaInfo/>
                      </Col>
                    </Row>
                </form>
            </div>
        );
    }
}
